import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  EmailTemplate,
  EmailTemplatesState as EmailTemplatesStateType,
  GetEmailTemplatesRequest,
} from '../../types/EmailTemplates.types';

export type EmailTemplatesState = EmailTemplatesStateType;

const initialState: EmailTemplatesState = {
  templates: [],
  loading: false,
  error: null,
};

const emailTemplatesSlice = createSlice({
  name: 'emailTemplates',
  initialState,
  reducers: {
    getEmailTemplatesRequest: (
      state,
      _action: PayloadAction<GetEmailTemplatesRequest>
    ) => {
      state.loading = true;
      state.error = null;
    },
    getEmailTemplatesSuccess: (
      state,
      action: PayloadAction<EmailTemplate[]>
    ) => {
      state.templates = action.payload;
      state.loading = false;
      state.error = null;
    },
    getEmailTemplatesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getEmailTemplatesRequest,
  getEmailTemplatesSuccess,
  getEmailTemplatesFailure,
} = emailTemplatesSlice.actions;

export default emailTemplatesSlice.reducer;
